import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'dashboard-civil-status',
  storeModule.createStoreModule('dashboard-civil-status', {
    fetchListURL: 'dashboard/civil-status'
  })
)
